const IS_MAIN = import.meta.env.VITE_VERCEL_GIT_COMMIT_REF === 'main';
const IS_DEMO = import.meta.env.VITE_VERCEL_GIT_COMMIT_REF === 'demo';
const IS_PRODUCTION = IS_MAIN || IS_DEMO;
const IS_PREVIEW = import.meta.env.VITE_VERCEL_ENV === 'preview';

// Dashboard specificity comes first, then global
const API_URL = import.meta.env.VITE_DASHBOARD_API_URL || import.meta.env.VITE_GLOBAL_API_URL;

export { API_URL, IS_MAIN, IS_DEMO, IS_PRODUCTION, IS_PREVIEW };
